import dynamic from "next/dynamic";

export const LegacyCookieConsent = dynamic(
  () => import("@/components/cookie-consent"),
  { ssr: false }
);

export const EnhancedCookieConsent = dynamic(
  () => import("@/components/enhanced-cookie-consent"),
  { ssr: false }
);
